module.exports = __webpack_public_path__ + "static/media/Icons- virus.a627e8ff.svg";